import React from "react";
import ReactDOM from "react-dom";
import "./App.css";
import "./SiteSections.css";
import "./index.css";
import App from "./App";
import Footer from "./Footer";
import Home from "./Home";
import * as serviceWorker from "./serviceWorker";

// Benign browser/dev-server noise when layout shifts during hex grid render.
window.addEventListener("error", (event) => {
  if (
    event.message ===
      "ResizeObserver loop completed with undelivered notifications." ||
    event.message === "ResizeObserver loop limit exceeded"
  ) {
    event.stopImmediatePropagation();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
    <Home />
    <Footer />
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
